import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { CheckBox, CheckboxProps } from '../Input';

import classes from './privacy-message.module.scss';
import * as React from 'react';

type PrivacyMessageProps = {
  newsletterAccepted: boolean;
  onChangeNewsletter: CheckboxProps['onCheckedChange'];
};

export const PrivacyMessage: FunctionComponent<PrivacyMessageProps> = ({
  newsletterAccepted,
  onChangeNewsletter,
}) => {
  return (
    <div className={classNames(classes.privacyMessage)}>
      <p style={{ marginBottom: '16px' }}>
        <CheckBox
          checked={newsletterAccepted}
          id={`newsletter-checkbox`}
          name={'Newsletter checkbox'}
          onCheckedChange={onChangeNewsletter}
        >
          Acconsento al trattamento dei miei dati personali da parte di Groupe
          SEB Italia S.p.A. per ricevere comunicazioni commerciali sui prodotti
          e servizi dei marchi di Groupe SEB Italia, anche personalizzate sulla
          base dei miei interessi e preferenze, via e-mail, SMS e MMS. In ogni
          caso, tale consenso potrà essere revocato in qualsiasi momento. Per
          ulteriori informazioni sul trattamento dei dati da parte di Groupe SEB
          Italia (incluso su come revocare il consenso), consulta l'
          <a href='https://lagostina.it/privacy-policy.pdf' target='_blank'>
            Informativa privacy di Groupe SEB Italia
          </a>
          .
        </CheckBox>
      </p>
    </div>
  );
};
